import { render } from "./template.vue?vue&type=template&id=565b6abc&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=565b6abc&lang=scss&scoped=true"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565b6abc"]])

export default __exports__